const NotificationStatuses = {
    Old: 'old',
    Latest: 'latest',
} as const;

export default NotificationStatuses;
